<template>
  <div>
    <v-container fluid>
      <div class="main">
        <v-row>
          <v-col cols="12">

            <v-row align="center">
              <v-col cols="10">
                <v-tabs background-color="transparent">

                  <v-tab @click="tab = 'tab-1'">
                    <v-icon left dense>mdi-account-multiple</v-icon>
                    Cibles utilisateurs
                  </v-tab>

                  <v-tab @click="tab = 'tab-2'">
                    <v-icon left dense>mdi-bullseye-arrow</v-icon>
                    Objectifs
                  </v-tab>

                </v-tabs>
              </v-col>
              <v-col cols="2" class="text-end">
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <UserTargets v-if="tab === 'tab-1'"/>
            <Objectives v-if="tab === 'tab-2'"/>
          </v-col>

        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import Objectives from "@/views/opus/objectives/components/objectives/index.vue";
import UserTargets from "@/views/opus/objectives/components/user_targets/index.vue";

export default {
  components: {UserTargets, Objectives},
  data() {
    return {
      tab: 'tab-1',
    }
  },
};
</script>

<style scoped>

</style>
